import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";

// const STRIPE_PROMISE = process.env.VITE_STRIPE_PROMISE;
// const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PROMISE);

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// const stripePromise = loadStripe(STRIPE_PROMISE);
const stripePromiseKey = import.meta.env.VITE_STRIPE_PROMISE;
const stripePromise = loadStripe(stripePromiseKey);

//   "pi_3O0kG7BpeqL5ix8p0AKK4ldk_secret_YHpaPAqTXBLC0R0nN981NAs8B";
const StripesPayment = ({ publicSecrete, setPaymentScreen, handleSucess }) => {
  const options = {
    clientSecret: publicSecrete,
  };
  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm
        publicSecret={publicSecrete}
        setPaymentScreen={setPaymentScreen}
        handleSucess={handleSucess}
      />
    </Elements>
  );
};
export default StripesPayment;
